import React, { useState } from "react";
import LiveSingleLotInfo from "../children/LiveSingleLotInfo";
import LiveBidingArea from "../children/LiveUpdatingArea";
import LiveLotsStatus from "./LiveLotsStatus";
import LiveBidingHistory from "../children/LiveBidingHistory";

function LiveLotsDetails({ liveOfferData, singleAuctionData, index }) {
  const [veiwBidDetails, setVeiwBidDetails] = useState(false);
  const [bidderDetails, setBidderDetails] = useState([]);
  return (
    <>
      <div
        className="liveLots pin-top"
        style={{
          border: "1px solid black",
          borderRadius: "12px 0px 12px 12px",
        }}
      >
        <div>{index}</div>
        <div
          style={{
            backgroundColor: "#fcf1ff",
            borderRadius: "12px 0px 12px 12px",
          }}
        >
          <LiveSingleLotInfo liveOfferData={liveOfferData} />
          <hr className="black" style={{ height: "0.5px" }} />
          <LiveBidingArea
            liveOfferData={liveOfferData}
            veiwBidDetails={veiwBidDetails}
            setVeiwBidDetails={setVeiwBidDetails}
            setBidderDetails={setBidderDetails}
            singleAuctionData={singleAuctionData}
          />
        </div>
        <LiveLotsStatus
          singleAuctionData={singleAuctionData}
          item={liveOfferData}
        />
      </div>
      {veiwBidDetails && (
        <LiveBidingHistory bidderDetails={bidderDetails} />
      )}
    </>
  );
}

export default LiveLotsDetails;
